<template>
  <div class="detail-box">
    <div 
      v-for="(item, index) in items" 
      :key="index" 
      class="detail-row"
    >
      <div class="detail-label">{{ item.label }}</div>
      <div class="detail-value">
        <template v-if="Array.isArray(item.value)">
          <div v-for="(val, i) in item.value" :key="i">{{ val }}</div>
        </template>
        <template v-else>
          {{ item.value }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailBox',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    boxTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.detail-box {
  width: 100%;
  border: 1px solid #e3e6ed;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.detail-row {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #e3e6ed;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  display: flex;
  align-items: stretch;
  width: 10rem;
  background-color: #f5faff;
  padding: 1rem;
  box-sizing: border-box;
  font-weight: bold;
  border-right: 1px solid #e3e6ed;
  align-self: stretch;
}

.detail-value {
  flex: 1;
  padding: 1rem;
}
</style> 